import React from 'react';
import PropTypes from 'prop-types';
import { Chip } from '@mui/material';
import {
  PIPELINE_RUN_STATUS_LABEL,
  PIPELINE_RUN_STATUS_CHIP_COLOR,
} from 'redux/slices/pipelines/constants/pipelineRunStatus';

// AC-16: keyed on the explicit numeric PipelineRunStatus value only — never an array
// index, never an invented string. An unrecognised/undefined status renders a safe
// fallback rather than throwing.
const PipelineRunStatusChip = ({ status, size = 'small' }) => {
  const label = PIPELINE_RUN_STATUS_LABEL[status];

  if (!label) {
    return (
      <Chip
        size={size}
        variant='outlined'
        label='No runs yet'
        color='default'
        aria-label='No runs yet'
      />
    );
  }

  return (
    <Chip
      size={size}
      label={label}
      color={PIPELINE_RUN_STATUS_CHIP_COLOR[status]}
      aria-label={`Run status: ${label}`}
    />
  );
};

export default React.memo(PipelineRunStatusChip);

PipelineRunStatusChip.propTypes = {
  status: PropTypes.number,
  size: PropTypes.oneOf(['small', 'medium']),
};
